import { FadeUp } from "./FadeUp";
import { useCountUp } from "../../hooks/useCountUp";

const COACH_PHOTO =
  "https://images.unsplash.com/photo-1707900285737-09a42c837118?crop=entropy&cs=srgb&fm=jpg&q=85";

const STATS = [{ end: 8, suffix: "+", label: "Years Training", testid: "coach-stat-years" }, { end: 10000, suffix: "+", label: "Transformations", testid: "coach-stat-transformations" }];

const Stat = ({ s }) => {
  const [ref, count] = useCountUp(s.end, 1500);
  return (
    <div ref={ref} data-testid={s.testid}>
      <p className="font-display text-3xl text-[#C6FF3D]">
        {count.toLocaleString()}
        {s.suffix}
      </p>
      <p className="text-[#A1A1AA] text-xs mt-1">{s.label}</p>
    </div>
  );
};

export const CoachSection = () => (
  <section id="coach" className="py-14 md:py-20 px-6 bg-[#0A0A0B]">
    <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 md:gap-14 items-center">
      <FadeUp className="flex justify-center">
        <div className="relative w-full max-w-sm">
          <div className="absolute -inset-4 bg-[#C6FF3D]/10 rounded-[32px] blur-2xl" />
          <img
            data-testid="coach-photo"
            src={COACH_PHOTO}
            alt="Coach Arjun, founder of FORGE, posing in the gym"
            className="relative rounded-[28px] w-full h-[380px] md:h-[460px] object-cover border border-[#232326]"
          />
        </div>
      </FadeUp>
      <FadeUp delay={0.15}>
        <span className="text-[#C6FF3D] text-xs font-semibold tracking-widest uppercase">Meet The Coach</span>
        <h2 className="font-display text-4xl sm:text-5xl text-white mt-3 mb-5">COACH ARJUN</h2>
        <p className="text-[#A1A1AA] text-base mb-8 max-w-lg">
          8+ years of training, 10,000+ transformations. FORGE puts my coaching method in your pocket.
        </p>
        <div className="flex gap-12">
          {STATS.map((s) => (
            <Stat key={s.label} s={s} />
          ))}
        </div>
      </FadeUp>
    </div>
  </section>
);
